import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { alpha } from '@mui/material/styles';
export function highlightMatch(_a) {
    var text = _a.text, searchTerm = _a.searchTerm, theme = _a.theme;
    if (!searchTerm || searchTerm.length < 2)
        return text;
    var regex = new RegExp("(".concat(searchTerm, ")"), 'ig');
    var parts = text.split(regex);
    return parts.map(function (part, i) {
        return part.toLowerCase() === searchTerm.toLowerCase() ? (_jsx("span", { style: {
                backgroundColor: alpha('#FFD66647', 0.28)
            }, children: part }, i)) : (_jsx(React.Fragment, { children: part }, i));
    });
}
